import { EventEmitterWeb } from './event-emitter.web';

export const event = new EventEmitterWeb();

export * from './types';
export * from './media';
export * from './actions';
